import { render, staticRenderFns } from "./SetupPaymentHeader.vue?vue&type=template&id=47174aba&"
import script from "./SetupPaymentHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SetupPaymentHeader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports